import { FC, useState } from "react";
import { useNavigation } from "../../hooks/useNavigation";
import { NavigationItem } from "../navigation/NavigationItem";
import { UserMenu } from "../user/UserMenu";

const APP_TITLE = "DataPortal";

export const Sidebar: FC = () => {
  const { navigationSections, navigateToPath, isActivePath } = useNavigation();
  const [hovered, setHovered] = useState(false);

  const collapsed = !hovered;

  return (
    <>
      {/* Spacer to reserve layout space (always collapsed width) */}
      <div className="shrink-0 w-[68px]" />

      <aside
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className={`fixed top-0 left-0 h-screen bg-white border-r border-border-light flex flex-col z-20 transition-all duration-300 ease-in-out
          ${collapsed ? "w-[68px]" : "w-[240px]"}`}
      >
        {/* Header */}
        <div
          className={`flex items-center h-[60px] shrink-0 border-b border-border-light overflow-hidden
            ${collapsed ? "justify-center px-2" : "px-4"}`}
        >
          <span
            className={`text-base font-bold text-text-heading tracking-tight whitespace-nowrap transition-opacity duration-300
              ${collapsed ? "opacity-0 w-0" : "opacity-100"}`}
          >
            {APP_TITLE}
          </span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-3">
          {navigationSections.map((section) => (
            <div key={section.label} className="mb-4">
              <div
                className={`px-4 pb-1 pt-2 text-[11px] font-semibold uppercase tracking-wider text-text-muted transition-opacity duration-300
                  ${collapsed ? "opacity-0 h-0 overflow-hidden p-0 m-0" : "opacity-100"}`}
              >
                {section.label}
              </div>
              <div className="space-y-1">
                {section.items.map((item) => (
                  <NavigationItem
                    key={item.path}
                    item={item}
                    isActive={isActivePath(item.path)}
                    collapsed={collapsed}
                    onClick={navigateToPath}
                  />
                ))}
              </div>
            </div>
          ))}
        </nav>

        {/* User panel */}
        <div className="shrink-0 border-t border-border-light py-3">
          <UserMenu collapsed={collapsed} />
        </div>
      </aside>
    </>
  );
};
